import React from 'react';
import { Link } from 'react-router-dom';
import { 
  TelegramLogo, 
  EnvelopeSimple 
} from '@phosphor-icons/react';
import Logo from './Logo';

const footerLinks = {
  product: [
    { name: 'Features', path: '/#features' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'API Access', path: '/api-access' },
    { name: 'Source Code', path: '/source-code' },
  ],
  company: [
    { name: 'About Us', path: '/about' },
    { name: 'Roadmap', path: '/#roadmap' },
    { name: 'Team', path: '/#team' },
    { name: 'Contact', path: '/contact' },
  ],
  resources: [
    { name: 'Documentation', path: '/docs' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Referral Program', path: '/referral' },
    { name: 'Support', path: '/contact' },
  ],
  legal: [
    { name: 'Terms of Use', path: '/terms' },
    { name: 'Privacy Policy', path: '/privacy' },
    { name: 'Terms & Conditions', path: '/conditions' },
    { name: 'Disclaimer', path: '/disclaimer' },
  ],
};

const socialLinks = [
  { icon: TelegramLogo, href: 'https://t.me/ai_defibot', label: 'Telegram' },
];

const Footer = () => {
  return (
    <footer 
      className="bg-[var(--bg-surface-1)] border-t border-[var(--border-default)]"
      data-testid="main-footer"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          {/* Brand Section */}
          <div className="col-span-2">
            <Logo size={40} />
            <p className="mt-4 text-sm text-[var(--text-secondary)] max-w-xs">
              AI-powered MEV & arbitrage trading terminal. Extract maximum value across 7 EVM networks.
            </p>
            <div className="flex gap-3 mt-6">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-2 rounded-lg bg-[var(--bg-surface-2)] text-[var(--text-secondary)] hover:text-[var(--color-primary)] hover:bg-[var(--color-primary)]/10 transition-all"
                  data-testid={`social-${social.label.toLowerCase()}`}
                >
                  <social.icon size={20} weight="bold" />
                </a>
              ))}
            </div>
          </div>

          {/* Links Sections */}
          <div>
            <h4 className="font-semibold text-sm text-[var(--text-primary)] mb-4">Product</h4>
            <ul className="space-y-2">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-sm text-[var(--text-secondary)] hover:text-[var(--color-primary)] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-[var(--text-primary)] mb-4">Company</h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-sm text-[var(--text-secondary)] hover:text-[var(--color-primary)] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-[var(--text-primary)] mb-4">Resources</h4>
            <ul className="space-y-2">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-sm text-[var(--text-secondary)] hover:text-[var(--color-primary)] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm text-[var(--text-primary)] mb-4">Legal</h4>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link 
                    to={link.path}
                    className="text-sm text-[var(--text-secondary)] hover:text-[var(--color-primary)] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-[var(--border-default)] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-[var(--text-secondary)]">
            &copy; 2021-2026 DeFiBot. All rights reserved.
          </p>
          <div className="flex items-center gap-2 text-sm text-[var(--text-secondary)]">
            <EnvelopeSimple size={16} />
            <a href="mailto:support@defi-bot.io" className="hover:text-[var(--color-primary)]">
              support@defi-bot.io
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
